import { render, staticRenderFns } from "./monthly.vue?vue&type=template&id=f2b2d964&scoped=true&"
import script from "./monthly.vue?vue&type=script&lang=js&"
export * from "./monthly.vue?vue&type=script&lang=js&"
import style0 from "./monthly.vue?vue&type=style&index=0&id=f2b2d964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b2d964",
  null
  
)

export default component.exports